import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

const formatDate = (date) => {
  const day = ('0' + date.getDate()).slice(-2)
  const month = ('0' + (date.getMonth()+1)).slice(-2)
  const year = date.getFullYear()

  return `${day}-${month}-${year}`
}

export const useFindStore = defineStore('findstore', () => {
  // Store Models
  const birthdate         = ref(null)
  const confirmationemail = ref("")
  const email             = ref("")
  const firstname         = ref("")
  const lastname          = ref("")
  const middlename        = ref("")
  const phone             = ref("")
  const tfn               = ref(null)
  const number            = ref(null)
  const tfnNow            = ref(true)

  const register_day            = ref(formatDate(new Date))
  const main_business_activity  = ref("")
  const address                 = ref("")
  const unit_number             = ref("")
  const street_number           = ref("")
  const route                   = ref("")
  const address_line_2          = ref("")
  const locality                = ref("")
  const state                   = ref("")
  const postal_code             = ref("")

  const address_line_1 = computed(() => {
    return [
      unit_number.value,
      street_number.value,
      route.value
    ]
      .filter(Boolean)
      .join(' ');
  });

  const resetData = () => {
    birthdate.value         = null
    confirmationemail.value = ''
    email.value             = ''
    firstname.value         = ''
    lastname.value          = ''
    middlename.value        = ''
    phone.value             = ''
    tfn.value               = null
    number.value            = null
    tfnNow.value            = true
    register_day.value      = formatDate(new Date())
    main_business_activity.value = ''
    address.value           = ''
    unit_number.value       = ''
    street_number.value     = ''
    route.value             = ''
    address_line_2.value    = ''
    locality.value          = ''
    state.value             = ''
    postal_code.value       = ''
  }

  const update = (order) => {
    if(order.register_day != null) {
      register_day.value     = order.register_day
    }

    birthdate.value         = order.birthdate ?? null
    confirmationemail.value = order.confirmationemail ?? order.email ?? ''
    email.value             = order.email ?? ''
    firstname.value         = order.firstname ?? ''
    lastname.value          = order.lastname ?? ''
    middlename.value        = order.middlename ?? ''
    phone.value             = order.phone ?? ''
    tfn.value               = order.tfn ?? null
    number.value            = order.number ?? null
    tfnNow.value            = !!order.tfn

    main_business_activity.value  = order.main_business_activity ?? ''
    address.value                 = order.address ?? ''
    street_number.value           = order.street_number ?? ''
    unit_number.value             = order.unit_number ?? ''
    route.value                   = order.route ?? ''
    address_line_2.value          = order.address_line_2 ?? ''
    locality.value                = order.locality ?? ''
    state.value                   = order.state ?? ''
    postal_code.value             = order.postal_code ?? ''
  }

  return {
    birthdate,
    confirmationemail,
    email,
    firstname,
    lastname,
    middlename,
    phone,
    tfn,
    number,
    tfnNow,
    resetData,
    update,
    register_day,
    main_business_activity,
    address,
    street_number,
    unit_number,
    route,
    address_line_1,
    address_line_2,
    locality,
    state,
    postal_code,
  }
}, { persist: true, })
